import ouiBase from '@goldwasserexchange/oui';
import { useAccountPositionFieldApiByGesEstimD } from '../api';

export const useAccountPositionGesEstimDPriceBuy = () => {
  const gesEstimDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountPositionFieldApiByGesEstimD({
    gesEstimDId,
    field: 'GES_ESTIM_D.PRICE_BUY',
  });
  return result;
};
